var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',[_c('template',{slot:"titlebreadcrumb"},[_vm._t("breadcrumb")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }